import Link from "next/link";
import { cn } from "@/app/lib/utils/cn";
import type { ReactNode } from "react";

interface PillLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
}

export default function PillLink({ href, children, className }: PillLinkProps) {
  return (
    <Link href={href} className={cn("link-brand", className)}>
      {children}
    </Link>
  );
}
